import { gql } from '@apollo/client';
import { MinSongFieldsFragment } from '../song/fragments';
import { MinEsongbookFieldsFragments } from '../songbook/fragments';

export const GET_NATIVITIES_MUSICALS = gql`
  query NativitiesMusicals {
    nativitiesMusicals {
      nativities {
        ...MinEsongbookFields
      }
      musicals {
        ...MinEsongbookFields
      }
      songbooks {
        ...MinEsongbookFields
      }
      songs {
        ...MinSongFields
      }
    }
  }
  ${MinEsongbookFieldsFragments}
  ${MinSongFieldsFragment}
`;

export const GET_PURCHASED_NATIVITIES = gql`
  query PurchasedNativities {
    purchasedNativities {
      ...MinEsongbookFields
    }
  }
  ${MinEsongbookFieldsFragments}
`;

export const GET_PURCHASED_MUSICALS = gql`
  query PurchasedMusicals {
    purchasedMusicals {
      ...MinEsongbookFields
    }
  }
  ${MinEsongbookFieldsFragments}
`;

export const GET_PURCHASED_SONGBOOKS = gql`
  query PurchasedSongbooks {
    purchasedSongbooks {
      ...MinEsongbookFields
    }
  }
  ${MinEsongbookFieldsFragments}
`;

export const GET_PURCHASED_SONGS = gql`
  query PurchasedSongs {
    purchasedSongs {
      ...MinSongFields
    }
  }
  ${MinSongFieldsFragment}
`;
